module.exports = __webpack_public_path__ + "img/floor_f10_01.a708df0e.png";